"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHue = void 0;
var utils_1 = require("../../utils");
exports.defaultHue = utils_1.orangeHue;
